import React from "react";
import ReactDOM from "react-dom/client";
import AppRouter from "./AppRouter";
import { register as registerServiceWorker } from "./serviceWorkerRegistration";
import { initInstallPrompt } from "./utils/installPrompt";

// Import Poppins font weights locally for offline support
import "@fontsource/poppins/400.css"; // Regular
import "@fontsource/poppins/500.css"; // Medium
import "@fontsource/poppins/600.css"; // SemiBold
import "@fontsource/poppins/700.css"; // Bold

// Before render: beforeinstallprompt fires early and is gone unless something
// catches it. See utils/installPrompt.js.
initInstallPrompt();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AppRouter />
  </React.StrictMode>,
);

if (process.env.NODE_ENV === "development") {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.getRegistrations().then((regs) => {
      regs.forEach((r) => r.unregister());
    });
  }
} else {
  registerServiceWorker();
}
